<script setup>
import FoodFlowModal from '@/components/FoodFlow/FoodFlowModal.vue';
import { ref, computed } from 'vue';

const emit = defineEmits(['close-modal']);

const form = ref({
    type: 'all',
    period: 'week',
    from: '',
    to: '',
});

const isCustomRange = computed(() => form.value.period === 'custom');
const exported = ref(false);

const exportWorkbook = () => {
    if (exported.value) {
        return;
    }

    const params = new URLSearchParams({
        type: form.value.type,
        period: form.value.period,
    });
    if (isCustomRange.value) {
        params.set('from', form.value.from);
        params.set('to', form.value.to);
    }

    window.location.href = '/api/v1/foodflow-sessions/export?' + params.toString();
    exported.value = true;
    setTimeout(() => emit('close-modal'), 1200);
};
</script>

<template>
<FoodFlowModal>
    <template #header>{{ $t('label.export_sessions') }}</template>

    <form class="flex flex-col gap-4" @submit.prevent="exportWorkbook">
        <div>
            <label class="mb-[7px] block text-[11px] font-bold uppercase tracking-[0.08em] text-[#375475]">{{ $t('label.session_type') }}</label>
            <select v-model="form.type" class="w-full rounded-[10px] border border-[#EDE8DF] bg-white px-3.5 py-2.5 text-[14px] text-[#1e2d3d] outline-none transition-colors focus:border-[#375475] focus:shadow-[0_0_0_3px_rgba(55,84,117,0.1)]">
                <option value="all">{{ $t('label.all_types') }}</option>
                <option value="intake">{{ $t('label.intake') }}</option>
                <option value="outtake">{{ $t('label.outtake') }}</option>
            </select>
        </div>
        <div>
            <label class="mb-[7px] block text-[11px] font-bold uppercase tracking-[0.08em] text-[#375475]">{{ $t('label.date_range') }}</label>
            <select v-model="form.period" class="w-full rounded-[10px] border border-[#EDE8DF] bg-white px-3.5 py-2.5 text-[14px] text-[#1e2d3d] outline-none transition-colors focus:border-[#375475] focus:shadow-[0_0_0_3px_rgba(55,84,117,0.1)]">
                <option value="week">{{ $t('label.this_week') }}</option>
                <option value="month">{{ $t('label.this_month') }}</option>
                <option value="quarter">{{ $t('label.this_quarter') }}</option>
                <option value="custom">{{ $t('label.custom_range') }}</option>
            </select>
        </div>
        <div v-if="isCustomRange" class="grid grid-cols-1 gap-2.5 sm:grid-cols-2">
            <div>
                <label class="mb-[7px] block text-[11px] font-bold uppercase tracking-[0.08em] text-[#375475]">{{ $t('label.from') }}</label>
                <input v-model="form.from" type="date" class="w-full rounded-[10px] border border-[#EDE8DF] bg-white px-3.5 py-2.5 text-[14px] text-[#1e2d3d] outline-none transition-colors focus:border-[#375475] focus:shadow-[0_0_0_3px_rgba(55,84,117,0.1)]">
            </div>
            <div>
                <label class="mb-[7px] block text-[11px] font-bold uppercase tracking-[0.08em] text-[#375475]">{{ $t('label.to') }}</label>
                <input v-model="form.to" type="date" class="w-full rounded-[10px] border border-[#EDE8DF] bg-white px-3.5 py-2.5 text-[14px] text-[#1e2d3d] outline-none transition-colors focus:border-[#375475] focus:shadow-[0_0_0_3px_rgba(55,84,117,0.1)]">
            </div>
        </div>
    </form>

    <template #footer>
        <div class="flex w-full justify-end gap-2.5">
            <button type="button" class="rounded-[10px] bg-[#EDE8DF] px-5 py-2.5 text-[14px] font-semibold text-[#64748b] hover:bg-[#d5cfc4]" @click="$emit('cancel-modal')">{{ $t('label.cancel') }}</button>
            <button
                type="button"
                class="inline-flex items-center gap-[7px] rounded-[10px] px-6 py-2.5 text-[14px] font-bold text-white transition-colors"
                :class="exported ? 'bg-[#61B245]' : 'bg-[#375475] hover:bg-[#4a6d93]'"
                :disabled="exported"
                @click="exportWorkbook">
                <FontAwesomeIcon :icon="exported ? 'check' : 'download'" />
                {{ exported ? $t('label.exported') : $t('label.export_excel') }}
            </button>
        </div>
    </template>
</FoodFlowModal>
</template>
